<template>
  <div>
    <ThePageTitleVue>
        <h3>{{ $t('market_2') }}</h3>
        <p>{{ $t('market_3') }}</p>
    </ThePageTitleVue>
    <div class="content" style="padding-bottom: 80px;">
      <div class="m-list">
        <div class="m-item" v-for="(item, index) in atcList" :key="index">
          <h4>{{ item.tLabel }}</h4>
          <p>{{ item.cLabel }}</p>
        </div>
      </div>


      <SymbolList style="margin-top: 80px" hideSeeMore />
    </div>
    
  </div>
</template>

<script>
import ThePageTitleVue from "./home/ThePageTitle.vue"
import SymbolList from './SymbolList'
export default {
  name: 'Market',
  components: {
    ThePageTitleVue,
    SymbolList,
  },
  data() {
    return {
      atcList: [
        {
          title: 'Forex',
          tLabel: this.$t('market_4'),
          content: 'Enjoy the freedom to trade-wherever you are. Our platforms are available on Windows and Mac OS for desktop, iOS and Androi for mobile and tablets.',
          cLabel: this.$t('market_5'),
        },{
          title: 'Commodities',
          tLabel: this.$t('market_6'),
          content: 'Enjoy the freedom to trade-wherever you are. Our platforms are available on Windows and Mac OS for',
          cLabel: this.$t('market_7'),
        },{
          title: 'Stocks',
          tLabel: this.$t('market_8'),
          content: 'Enjoy the freedom to trade-wherever you are. Our platforms are available on Windows and Mac OS for desktop, iOS and Androi for mobile and tablets.',
          cLabel: this.$t('market_9'),
        },{
          title: 'Indices',
          tLabel: this.$t('market_10'),
          content: 'Enjoy the freedom to trade-wherever you are. Our platforms are available on Windows and Mac OS for desktop, iOS and Androi for mobile and tablets.',
          cLabel: this.$t('market_11'),
        },
      ]
    }
  },
}
</script>

<style scoped lang="scss">
.m-list{
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
  .m-item{
    width: 250px;
    h4{
      height: 30px;
      font-size: 18px;
      font-weight: bold;
      color: #181D24;
      line-height: 40px;
    }
    p{
      font-size: 16px;
      font-weight: 400;
      color: #5C6E7B;
      line-height: 24px;
      margin-top: 10px;
    }
  }
  .m-item:nth-child(5){
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Market.vue